<project-details-breadcrumb-version-header  *ngIf="status != STATUS_NOT_ALLOWED"
  [hidden]="status == STATUS_NOT_FOUND"
  [project]="project"
  [version]="version"
  [exclude]="excludedLabels"
  [title]="bcTitle"
  [breadcrumbs]="breadcrumbs"
></project-details-breadcrumb-version-header>
<div class="loader">
  <div class="dimmed" [hidden]="status != STATUS_LOADING">
      <div class="dimmed_flex">
          <div class="dimmed_versions dimmed_content">
              <div class="dimmed_title"></div>
              <div class="dimmed_subtitle"></div>
              <div class="dimmed_subtitle"></div>
          </div>
          <div class="dimmed_status"></div>
      </div>
  </div>
</div>
<div *ngIf="status == STATUS_DONE" class="artwork-upload-main" [ngClass]="{'with-overlay': view !=  VIEW_UPLOAD_VERSION_NONE}">
  <core-layout-modal-feedback class="modal-feedback modal-upload-version-success" *ngIf="view == VIEW_UPLOAD_VERSION_DONE"
    [type]="'done'"
    [message]="'New version sent'"
    [buttonText]="'Done'"
    (action)="onNewVersionSentDone($event)">
  </core-layout-modal-feedback>
  <core-layout-modal-feedback class="modal-feedback modal-reminder-error" *ngIf="view == VIEW_UPLOAD_VERSION_ERROR"
    [type]="'fail'"
    [message]="'Error'"
    [text]="modalUploadErrorText"
    [buttonText]="'Go back'"
    (action)="onNewVersionSentError($event)">
  </core-layout-modal-feedback>
  <ng-container *ngIf="userVersionShare != null  && currentVersionShare">
    <div class="request-upload-artwork">
        <core-versions-upload-version-box
              [version]="version"
              [actionButton]="false"
              [versionShare]="userVersionShare"
              [uploadVersion]="currentVersionShare"
          ></core-versions-upload-version-box>
      </div>
    
      <!-- <ng-container *ngIf="userVersionShare.status.status_code == UPLOAD_STATUS.OPENED_CODE"> -->
      <ng-container *ngIf="currentVersionShare.upload != null && currentVersionShare.upload.version == null">
        <!-- start form for version add -->
        <header class="sg-header">
          <h3>UPLOAD VERSION</h3>
        </header>
        <div class="artwork-upload-box box_default box_white">
          <!-- upload files -->
          <article class="version-upload-section">          
            <div class="artwork-upload-item version-upload-status">
              <h4>THIS ARTWORK WILL BE SAVED AS</h4>
              <div class="status">
                <div class="status-main">
                  <span [style.background-color]="versionStatus.color">{{versionStatus.name}}</span>
                </div>
              </div>
            </div>
            <!-- What clases are element & text-upload if they are files-->
          
            <div class="artwork-upload-item upload-files"> 
              <h4>ARTWORK FILES</h4>
              <div class="loader" *ngIf="submitted else uploaderdisplayed">
                <div class="dimmed" >
                    <div class="dimmed_box"></div>
                    <div class="dimmed_flex">
                        <div class="dimmed_title"></div>
                        <div class="dimmed_title"></div>
                    </div>
                </div>
              </div>
              <ng-template #uploaderdisplayed>
                <section [ngClass]="{'upload-version-validation-error': filesError}">
                  <core-storage-files-upload 
                    (response)='upload($event)'
                    (onUploading)="uploading = $event"></core-storage-files-upload>
                </section>
              </ng-template>
            </div>
          </article>
          <!-- buttons -->
          <div class="box_fieldset">
            <core-helpers-forms-button-white [disabled]="!isVersionReady()|| uploading" [text]="'Upload'"
              (click)="onSubmit()"></core-helpers-forms-button-white>
            <core-helpers-forms-button [type]="'grey'" [text]="'Cancel'" (click)="onCancel()"></core-helpers-forms-button>
          </div>
          <!-- -->
        </div>
        <!-- finish form for version add -->
      </ng-container>

  </ng-container>
</div>
<div class="version-details-forbidden"  *ngIf="status == STATUS_NOT_ALLOWED && version != null">

  <core-helpers-box-alert-message-icon
    [text]="'You don’t have permission to see this section'"
    [icon]="'alert'"
  ></core-helpers-box-alert-message-icon>
</div>

<core-helpers-box-http-error
    *ngIf="status == STATUS_NOT_FOUND"
    [code]="404"
    [message]="'Not found.'"
></core-helpers-box-http-error>

<core-helpers-box-http-error
    *ngIf="status == STATUS_ERROR"
    [code]="500"
    [message]="'Error. Check your url'"
></core-helpers-box-http-error>
